import { BasicPassFragment } from 'drycut-graphql';
import { twMerge } from 'tailwind-merge';
import { Para, Stack } from 'ui-components';

type Props = {
  pass: BasicPassFragment;
  className?: string;
};

export default function PassPrice({
  pass: { price, basePrice },
  className,
}: Props): React.ReactElement {
  const baseClasses = 'items-center justify-center';
  const classes = twMerge(baseClasses, className);

  return (
    <Stack direction="row" gap={2} className={classes}>
      <Para size="2xl">{price} CHF</Para>
      <Para className="text-zinc-500">(statt {basePrice} CHF)</Para>
    </Stack>
  );
}
